/**
 * Generated by orval 🍺
 * Do not edit manually.
 * STBportalen
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  RiskAssesmentContainerDto
} from '../../model';

import { customInstance } from '../../../mutator/custom-instance';
import type { ErrorType , BodyType } from '../../../mutator/custom-instance';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiRiskAssesmentProjectId = (
    projectId: number,
 signal?: AbortSignal
) => {


      return customInstance<RiskAssesmentContainerDto>(
      {url: `/api/RiskAssesment/${projectId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiRiskAssesmentProjectIdQueryKey = (projectId: number,) => {
    return [
    `/api/RiskAssesment/${projectId}`
    ] as const;
    }


export const getGetApiRiskAssesmentProjectIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiRiskAssesmentProjectId>>, TError = ErrorType<unknown>>(projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRiskAssesmentProjectId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiRiskAssesmentProjectIdQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiRiskAssesmentProjectId>>> = ({ signal }) => getApiRiskAssesmentProjectId(projectId, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiRiskAssesmentProjectId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiRiskAssesmentProjectIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiRiskAssesmentProjectId>>>
export type GetApiRiskAssesmentProjectIdQueryError = ErrorType<unknown>


export function useGetApiRiskAssesmentProjectId<TData = Awaited<ReturnType<typeof getApiRiskAssesmentProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRiskAssesmentProjectId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRiskAssesmentProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiRiskAssesmentProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiRiskAssesmentProjectId<TData = Awaited<ReturnType<typeof getApiRiskAssesmentProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRiskAssesmentProjectId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRiskAssesmentProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiRiskAssesmentProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiRiskAssesmentProjectId<TData = Awaited<ReturnType<typeof getApiRiskAssesmentProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRiskAssesmentProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiRiskAssesmentProjectId<TData = Awaited<ReturnType<typeof getApiRiskAssesmentProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRiskAssesmentProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiRiskAssesmentProjectIdQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiRiskAssesment = (
    riskAssesmentContainerDto?: BodyType<RiskAssesmentContainerDto>,
 signal?: AbortSignal
) => {


      return customInstance<RiskAssesmentContainerDto>(
      {url: `/api/RiskAssesment`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: riskAssesmentContainerDto, signal
    },
      );
    }




export const getPutApiRiskAssesmentMutationKey = () => ['putApiRiskAssesment'] as const;

export const getPutApiRiskAssesmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiRiskAssesment>>, TError,PutApiRiskAssesmentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiRiskAssesment>>, TError,PutApiRiskAssesmentMutationVariables, TContext> => {

const mutationKey = getPutApiRiskAssesmentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiRiskAssesment>>, PutApiRiskAssesmentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putApiRiskAssesment(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiRiskAssesmentMutationResult = NonNullable<Awaited<ReturnType<typeof putApiRiskAssesment>>>
    export type PutApiRiskAssesmentMutationBody = BodyType<RiskAssesmentContainerDto> | undefined
    export type PutApiRiskAssesmentMutationError = ErrorType<unknown>
    export type PutApiRiskAssesmentMutationVariables = {data?: BodyType<RiskAssesmentContainerDto>}

    export const usePutApiRiskAssesment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiRiskAssesment>>, TError,PutApiRiskAssesmentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiRiskAssesment>>,
        TError,
        PutApiRiskAssesmentMutationVariables,
        TContext
      > => {
      return useMutation(getPutApiRiskAssesmentMutationOptions(options), queryClient);
    }
